import { mutatorAction } from 'satcheljs';
import { getCopilotCategoriesList } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import type CopilotCategoryType from '../store/schema/CopilotCategoryType';
import { setItem, type LocalStorageKeys } from 'owa-local-storage';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';

/**
 * Removes the client category type
 * @param ClientCategoryType the client category type
 * @param mailboxInfo the mailbox info
 */
export const removeCopilotCategory = (categoryNames: string[], mailboxInfo: MailboxInfo): void => {
    for (const category of categoryNames) {
        removeCopilotCategoryInternal(category, mailboxInfo);
    }
    const localStorageKey: LocalStorageKeys = `mail_copilot_categories${getIndexerValueForMailboxInfo(
        mailboxInfo
    )}`;
    setItem(window, localStorageKey, JSON.stringify(getCopilotCategoriesList(mailboxInfo)));
};

/**
 * Removes the client category type in store
 * @param categoryName  the client category name
 * @param mailboxInfo the mailbox info
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const removeCopilotCategoryInternal = mutatorAction(
    'removeCopilotCategoryInternal',
    (categoryName: string, mailboxInfo: MailboxInfo) => {
        const categoryList = getCopilotCategoriesList(mailboxInfo);
        const index = categoryList.findIndex(
            (category: CopilotCategoryType) => category.Name === categoryName
        );
        if (index > -1) {
            categoryList.splice(index, 1);
        }
    }
);
